export const API_URI = 'https://api.car-wash.greenlineclean.eu/api'
export const DEFAULT_LOCALE = 'hu'
export const AUTH_COOKIE_KEY = 'cwo_tok_'
export const WASHERID_COOKIE_KEY = 'cwo_swid'
export const PREFERRED_CALENDARVIEW_COOKIE_KEY = 'prefcalview'
